export default "__VITE_ASSET__Dal3MpHS__"